/**
 * HYCO PDP product gallery: main Swiper with thumbs, navigation, and bullets.
 * Expects window.Swiper from vendor-swiper-bundle.min.js.
 */

(function () {
  'use strict';

  /** @type {WeakMap<object, { main: object, thumbs: object }>} */
  const instancesByRoot = new WeakMap();

  /**
   * @param {HTMLElement} root
   */
  function destroyGallery(root) {
    const pair = instancesByRoot.get(root);

    if (!pair) {
      return;
    }

    if (pair.main && !pair.main.destroyed) {
      pair.main.destroy(true, true);
    }

    if (pair.thumbs && !pair.thumbs.destroyed) {
      pair.thumbs.destroy(true, true);
    }

    instancesByRoot.delete(root);
  }

  /**
   * @param {HTMLElement} root
   */
  function initGallery(root) {
    const SwiperCtor = window.Swiper;

    if (!SwiperCtor) {
      return;
    }

    const mainEl = root.querySelector('.hyco-pdp-gallery__main');
    const thumbsEl = root.querySelector('.hyco-pdp-gallery__thumbs');

    if (!mainEl || !thumbsEl) {
      return;
    }

    const slideCount = mainEl.querySelectorAll('.swiper-slide').length;

    if (slideCount === 0) {
      return;
    }

    destroyGallery(root);

    const prevEl = root.querySelector('.hyco-pdp-gallery__nav--prev');
    const nextEl = root.querySelector('.hyco-pdp-gallery__nav--next');
    const pagEl = root.querySelector('.hyco-pdp-gallery__pagination');

    const thumbsSwiper = new SwiperCtor(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
    });

    const mainSwiper = new SwiperCtor(mainEl, {
      speed: 400,
      watchOverflow: true,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : false,
      pagination: pagEl
        ? {
            el: pagEl,
            clickable: true,
          }
        : false,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });

    instancesByRoot.set(root, {
      main: mainSwiper,
      thumbs: thumbsSwiper,
    });
  }

  /**
   * @param {HTMLElement} sectionEl
   */
  function initInSection(sectionEl) {
    const root = sectionEl.querySelector('[data-hyco-pdp-gallery]');

    if (root) {
      initGallery(root);
    }
  }

  /**
   * @param {HTMLElement} sectionEl
   */
  function destroyInSection(sectionEl) {
    const root = sectionEl.querySelector('[data-hyco-pdp-gallery]');

    if (root) {
      destroyGallery(root);
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-hyco-pdp-gallery]')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target instanceof HTMLElement) {
      initInSection(ev.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    if (ev.target instanceof HTMLElement) {
      destroyInSection(ev.target);
    }
  });
})();
